// Framework and third-party non-UI
import React, { useRef, useState } from 'react';

// Redux, contexts, and local helpers/utils/modules

// Component specific modules (Component-styled, etc.)

// App components

// Third-party components (buttons, icons, etc.)
import { CalciteButton, CalciteTooltip } from 'components/Calcite';

interface CopyToClipboardProps {
  name: string;
  copyValue: string;
}

const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
  name,
  copyValue
}) => {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const onClick = () => {
    timeoutRef.current && clearTimeout(timeoutRef.current);
    setCopied(true);
    navigator.clipboard.writeText(copyValue);
    timeoutRef.current = setTimeout(() => setCopied(false), 3000);
  };

  const button = (
    <CalciteButton
      id={`copy-to-clipboard-button-${name}`}
      appearance="transparent"
      iconStart={copied ? 'check' : 'copy-to-clipboard'}
      onClick={onClick}
    />
  );

  return (
    <>
      {copied ? (
        <>
          <CalciteTooltip
            placement="top"
            referenceElement={`copy-to-clipboard-button-${name}`}
          >
            Copy
          </CalciteTooltip>
          {button}
        </>
      ) : (
        button
      )}
    </>
  );
};

export default CopyToClipboard;
